import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useFeatures } from '../context/FeatureContext';
import CompanySetupLayout from '../jsx/components/Onboarding/CompanySetupLayout';
import BillingAccessRequired from '../jsx/pages/BillingAccessRequired';

export default function BillingAccessGate({ children }) {
    const { entitlements, hasLoaded, isLoading, refreshEntitlements } = useFeatures();
    const location = useLocation();
    const match = location.pathname.match(/^\/([0-9a-f-]{36})(?:\/|$)/i);
    const companyId = match?.[1];
    if (companyId && (!hasLoaded || entitlements?.companyId !== companyId)) {
        const failed = hasLoaded && !isLoading && !entitlements;
        return <CompanySetupLayout><div className="company-setup-status" role="status">
            <h1>{failed ? 'Kunde inte hämta företaget' : 'Vi förbereder ditt företag'}</h1>
            <p>{failed ? 'Försök igen för att hämta företagets prenumeration.' : 'Hämtar prenumeration och åtkomst…'}</p>
            {failed && <button className="company-setup-button" onClick={refreshEntitlements}>Försök igen</button>}
        </div></CompanySetupLayout>;
    }
    const choosingPlan = location.pathname === `/${companyId}/choose-plan`;
    const settingsPath = `/${companyId}/settings`;
    const inSettings = location.pathname === settingsPath || location.pathname.startsWith(`${settingsPath}/`);
    const query = new URLSearchParams(location.search);
    const legacyCheckoutReturn = inSettings && query.get('payment') === 'plan_success';
    if (companyId && !choosingPlan && (legacyCheckoutReturn || entitlements?.planSelectionRequired || entitlements?.billingAccess?.code === 'BILLING_PLAN_SELECTION_REQUIRED')) {
        return <Redirect to={{ pathname: `/${companyId}/choose-plan`, search: location.search }} />;
    }
    // Old reminder/Checkout links used query tabs. Preserve session parameters
    // while sending them to the current settings section before it mounts.
    if (companyId && ((location.pathname.replace(/\/$/, '') === settingsPath && (query.get('tab') === 'subscription' || query.has('payment'))) || location.pathname === `/${companyId}/subscription`)) {
        query.delete('tab');
        return <Redirect to={{ pathname: `${settingsPath}/subscription`, search: query.toString() ? `?${query}` : '', hash: location.hash }} />;
    }
    return children;
}

// Place inside the app layout so navigation stays visible while blocked route
// components (and their data requests) are replaced by the recovery card.
export function BillingContentGate({ children }) {
    const { entitlements, hasLoaded, refreshEntitlements } = useFeatures();
    const location = useLocation();
    const companyId = location.pathname.match(/^\/([0-9a-f-]{36})(?:\/|$)/i)?.[1];
    const settingsPath = `/${companyId}/settings`;
    const inSettings = location.pathname === settingsPath || location.pathname.startsWith(`${settingsPath}/`);
    if (hasLoaded && companyId && entitlements?.companyId === companyId &&
        entitlements?.billingAccess?.allowed === false && !inSettings) {
        // Keep the requested URL. Once access is restored, the intended page
        // opens naturally inside the same app layout.
        return <BillingAccessRequired key={companyId} companyId={companyId} entitlements={entitlements} onRefresh={refreshEntitlements} />;
    }
    return children;
}
